<template>
  <div>
    <div class="d-flex justify-content-center">
      <div class="hstack gap-5">
        <span class="pointer" @click="prev"
          ><i class="bi bi-chevron-left"></i> 이전</span
        >
        <h5>{{ viewDate.getFullYear() }}년 {{ viewDate.getMonth() + 1 }}월</h5>
        <span class="pointer" @click="next"
          >다음<i class="bi bi-chevron-right"></i
        ></span>
      </div>
    </div>
    <div class="mb-5"></div>
    <div class="d-flex date-header">
      <div class="d-flex flex-fill justify-content-around">
        <span class="weekend">일</span>
        <span>월</span>
        <span>화</span>
        <span>수</span>
        <span>목</span>
        <span>금</span>
        <span class="weekend">토</span>
      </div>

      <div class="d-none d-md-flex flex-fill justify-content-around">
        <span class="weekend">일</span>
        <span>월</span>
        <span>화</span>
        <span>수</span>
        <span>목</span>
        <span>금</span>
        <span class="weekend">토</span>
      </div>

      <div class="d-none d-md-flex flex-fill justify-content-around">
        <span class="weekend">일</span>
        <span>월</span>
        <span>화</span>
        <span>수</span>
        <span>목</span>
        <span>금</span>
        <span class="weekend">토</span>
      </div>
    </div>
    <div class="mb-2"></div>
    <div class="d-flex date flex-column flex-md-row">
      <div
        v-for="i in 3"
        :key="i"
        class="d-flex flex-fill justify-content-around"
      >
        <span
          v-for="j in 7"
          :key="j"
          :class="{
            today: isToday(dates[(i - 1) * 7 + (j - 1)]),
            selected: isSameDate(dates[(i - 1) * 7 + (j - 1)], selectedDate),
          }"
          @click="selectedDate = dates[(i - 1) * 7 + (j - 1)]"
        >
          {{ dates[(i - 1) * 7 + (j - 1)].getDate() }}
        </span>
      </div>
    </div>
    <div class="d-flex date flex-column flex-md-row">
      <div
        v-for="i in 3"
        :key="i"
        class="d-flex flex-fill justify-content-around"
      >
        <span v-for="j in 7" :key="j" class="disabled">
          {{ dates[(i + 2) * 7 + (j - 1)].getDate() }}
        </span>
      </div>
    </div>
    <div class="m-5"></div>
    <div class="d-flex flex-wrap gap-3 pointer justify-content-center">
      <a
        class="time"
        v-for="i in 6"
        :key="i"
        :class="{ selected: i === selectedTimeIdx }"
        @click="selectedTimeIdx = i"
        :href="nextStepUrl"
        >16:00 - 17:30</a
      >
    </div>
  </div>
</template>

<script>
const weeks = 6;
export default {
  name: "EpiMeetingPicker",
  props: ["nextStepUrl"],
  data() {
    return {
      viewDate: new Date(),
      today: new Date(),
      weeks: weeks,
      selectedDate: new Date(),
      selectedTimeIdx: 0,
    };
  },
  computed: {
    dates() {
      const start = new Date(this.viewDate);
      start.setDate(start.getDate() - 7); // a week ago
      start.setDate(start.getDate() - start.getDay()); // and set to start of the week

      const arr = [];
      for (let i = 0; i < weeks * 7; i++)
        arr.push(new Date(new Date(start).setDate(start.getDate() + i)));

      return arr;
    },
  },
  methods: {
    prev() {
      const d = this.viewDate.setDate(this.viewDate.getDate() - 21);
      this.viewDate = new Date(d);
    },
    next() {
      const d = this.viewDate.setDate(this.viewDate.getDate() + 21);
      this.viewDate = new Date(d);
    },
    isToday(d) {
      return this.isSameDate(d, new Date());
    },
    isSameDate(a, b) {
      return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
purple-light = 171 172 211
purple-dark = 137 141 193
apricot-light = 252 236 227
apricot-dark = 254 235 226

.date-header
  border-bottom 1px solid rgba(0,0,0,0.3)
  padding-bottom 5px

  & span
    width 30px
    height 30px
    text-align center
    font-size 0.9rem

    &.weekend
      color rgba(250, 20, 0, 0.83)

.date
  & span
    padding-top 5px
    width 30px
    height 30px
    text-align center
    cursor pointer
    border-radius 100%
    font-weight bold

    &.selected
      background-image linear-gradient(45deg, rgb(purple-dark), rgba(purple-light, 0.5))
      color white

    &.disabled
      color rgba(0,0,0,0.2)

    &.today
      text-decoration underline

a.time
  border 1px solid rgba(0 0 0 0.3)
  border-radius 15px
  padding 5px 25px
  text-decoration none
  color var(--bs-body-color)

  &.selected
    border 1px rgb(purple-dark)
    background-image linear-gradient(45deg, rgb(purple-dark), rgba(purple-light, 0.5))
    color white
</style>
